import { useParams, useSearchParams } from 'react-router-dom';

import { useExample, useExamples } from '@/hooks/useSwr';

export function useExampleData({ exampleId }: { exampleId?: string }) {
  const params = useParams();
  const myExampleId = exampleId ?? params.exampleId;

  const [searchParams] = useSearchParams();
  const asOfRaw = searchParams.get('as_of');
  const asOf = asOfRaw ? decodeURIComponent(asOfRaw) : undefined;
  const datasetShareToken = params.datasetShareToken;

  const privateExample = useExample(
    datasetShareToken ? null : myExampleId ?? null,
    asOf
      ? {
          as_of: asOf,
        }
      : undefined
  );
  const publicExamples = useExamples(
    myExampleId && datasetShareToken
      ? {
          id: [myExampleId],
          ...(asOf ? { as_of: asOf } : {}),
        }
      : null,
    {
      datasetShareToken,
    }
  );

  const example = datasetShareToken
    ? publicExamples.data?.[0]
    : privateExample.data;
  return {
    data: example,
    isLoading: privateExample.isLoading || publicExamples.isLoading,
    error: privateExample.error || publicExamples.error,
    mutate: privateExample.mutate || publicExamples.mutate,
  };
}
